import {AbstractModel} from "./abstract-model";
import {Document} from './document';

export class User extends AbstractModel {
  id: number | null = null;
  email: string | null = null;
  firstname: string | null = null;
  lastname: string | null = null;
  nickname: string | null = null;
  teams: string | null = null;
  telegram: string | null = null;
  phone: string | null = null;
  loggedAt: Date | null = null;
  enabled: boolean | null = null;
  authorizedCountries: string[] = [];
  authorizedIps: string[] = [];
  accountManager: boolean = false;
  teamManager: boolean = false;
  manager: User | null = null;
  roles: string[] = [];
  image: Document | null = null;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.manager) {
      this.manager = new User().deserialize(input.manager);
    }

    if (input.image) {
      this.image = new Document().deserialize(input.image);
    }

    return this;
  }

  override toString(): string {
    let name = '';

    if (this.firstname) {
      name += this.firstname;
    }

    if (this.lastname) {
      name += ' ' + this.lastname;
    }

    return name.trim();
  }
}
